import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Hidden,
  Button,
} from '@material-ui/core';

import * as routes from '../../config/routes';
import classes from '../../css/getCSS';


const commonNavItems = () => {
  return (
    <Hidden smDown>
      <Link to={formatRoute(routes.STATIC_PAGES, { page: 'about' })} className={classes.linkDeCSS}>
        <Button variant="flat" color="inherit">About</Button>
      </Link>
      <Link to={formatRoute(routes.STATIC_PAGES, { page: 'services' })} className={classes.linkDeCSS}>
        <Button variant="flat" color="inherit">Services</Button>
      </Link>
      <Link to={formatRoute(routes.EVENTS)} className={classes.linkDeCSS}>
        <Button variant="flat" color="inherit">Events</Button>
      </Link>
      <Link to={formatRoute(routes.NEWS)} className={classes.linkDeCSS}>
        <Button variant="flat" color="inherit">News</Button>
      </Link>
      <Link to={formatRoute(routes.GALLERY)} className={classes.linkDeCSS}>
        <Button variant="flat" color="inherit">Gallery</Button>
      </Link>
    </Hidden>
  );
};

export default commonNavItems;



// WEBPACK FOOTER //
// ./src/common/components/CommonNavItems.js